export default {
  group: 'form-group',
  select: 'form-control',
  option: '',
}



// WEBPACK FOOTER //
// src/common/form-elements/select-element-folder/select-element.style.js